export default __webpack_public_path__ + "ea886b41e25a97709366eb79adb79864.png";